import React, { useEffect, useState } from "react";
import "../assets/css/Webinar.css";
import web from '../assets/home-page-imgs/webinar.jpg';
import hero from '../assets/Gallery/event-hero.png';
import aLogo from '../assets/Gallery/aarambh-logo.png';

import AarambhGallery from "./AarambhGallery";




const Webinar = () => {

  const EVENT_DATE = new Date("2026-02-13T10:00:00"); // IST Event Time



  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const [timeLeft, setTimeLeft] = useState({
    days: 12,
    hours: 4,
    minutes: 36,
    seconds: 18,
  });



  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = EVENT_DATE.getTime() - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, []);



  /* Scroll Reveal */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("active");
        });
      },
      { threshold: 0.15 }
    );

    document
      .querySelectorAll(".sg-event-reveal")
      .forEach((el) => observer.observe(el));
  }, []);

  return (
    <>
      {/* HERO */}
      <section className="sg-event-hero">
        <div className="sg-event-hero-overlay" />

        <div className="sg-event-hero-content sg-event-reveal">
          <h1 className="sg-event-hero-title">
            {/* <span>AARAMBH</span> */}
            <span><img src={aLogo} className="alogo"></img></span>


            <span>Your First Powerful Step into Real Estate Success</span>
            {/* <span>15+ Industry Experts</span> */}
          </h1>

          <p className="sg-event-hero-subtitle">
            1 Day • Live Event • Pune <br />
            Learning • Networking • Certification
            <br />
            <br />
            Meet us at Real Estate AARAMBH to learn, grow, and build your future in real estate.
          </p>

          <div className="sg-event-hero-buttons">
            {/* <button className="sg-event-btn primary">Explore Events</button> */}

            <div className="sg-event-urgency">
              ⚠️ Limited Seats Available
            </div>

            <button
              className="sg-event-btn primary"
              onClick={() => setShowRegisterModal(true)}
            >
              Register Now
            </button>

          </div>
        </div>
      </section>



      {/* COUNTDOWN */}
      <section className="sg-event-countdown sg-event-reveal">
        {/* <div className="aarambh-date">13<sup>th</sup> Feb 2026 <br />
          Venue : The Pride Hotel, Pune | 10:00 AM To 4:00 PM
        </div> */}
        <div className="aarambh-date">Coming Soon
        </div>

        <h3>Real Estate AARAMBH Starts In</h3>
        <div className="sg-event-timer">
          {Object.entries(timeLeft).map(([key, val]) => (
            <div key={key}>
              <span>{val}</span>
              <label>{key}</label>
            </div>
          ))}
        </div>
      </section>

      {/* HIGHLIGHTS */}
      <section className="sg-event-highlights">
        <h2 className="sg-event-title sg-event-reveal">
          What You’ll Experience
        </h2>

        <div className="sg-event-card-grid">
          {[
            "Growth Opportunities in Real Estate",
            "Expert Guidance & Learning",
            "Real Estate Starter Kit",
            "Certificate of Participation",
            "High Tea & Networking",
            "Entry Fee: ₹499 Only",
            "Limited Seats | First Come First Serve",
          ].map((item, i) => (
            <div
              className="sg-event-card sg-event-reveal"
              style={{ transitionDelay: `${i * 120}ms` }}
              key={i}
            >
              <h4>{item}</h4>
              <p>
                <p>
                  {/* Designed to help you confidently start or scale your journey in real estate. */}
                </p>

              </p>
            </div>
          ))}
        </div>                                                  
    
      </section>


        <AarambhGallery />



      {/* ABOUT */}
      <section className="sg-event-about sg-event-reveal">
        <span className="sg-event-tag">About Gurukul Events</span>
        <h2 className="sg-event-title">
          Learning That Builds Real Estate Careers
        </h2>
        <p className="sg-event-desc">
          Samriddhi Gurukul Events & Webinars are crafted to deliver practical,
          execution-focused learning for aspiring and professional real estate
          channel partners. Every session is designed to help you grow with
          confidence.
        </p>
      </section>

      {/* UPCOMING EVENTS */}
      <section className="sg-event-list">
        <h2 className="sg-event-title sg-event-reveal">
          Upcoming Events & Webinars
        </h2>

        <div className="sg-event-list-grid">
          <div className="sg-event-item sg-event-reveal">
            <span className="sg-event-date">24 Feb -2026</span>
            <h4>How to Close ₹1Cr+ Deals as a Channel Partner</h4>
            <p>Live Webinar • Hindi + English</p>
            <button className="sg-event-btn primary">Register</button>
          </div>

          <div className="sg-event-item sg-event-reveal">
            <span className="sg-event-date">24 Mar - 2026</span>
            <h4>Real Estate Lead Generation Blueprint</h4>
            <p>Online Session</p>
            <button className="sg-event-btn primary">Register</button>
          </div>
        </div>
      </section>

      {/* ================= REGISTER MODAL ================= */}
      {showRegisterModal && (
        <>
          <div
            className="sg-event-modal-backdrop"
            onClick={() => setShowRegisterModal(false)}
          ></div>

          <div className="sg-event-modal">
            <div className="sg-event-modal-box sg-event-reveal">
              <h2 className="sg-event-modal-title">
                Register for <span>REAL ESTATE AARAMBH</span>
              </h2>

              {/* Personal Details */}
              <h4 className="sg-event-form-heading">Personal Details</h4>

              <input type="text" placeholder="Full Name *" required />
              <input type="tel" placeholder="Mobile Number *" required />
              <input type="email" placeholder="Email ID *" required />

              <select required>
                <option value="">Age Group *</option>
                <option>18–25</option>
                <option>26–35</option>
                <option>36–45</option>
                <option>45+</option>
              </select>

              {/* Professional Details */}
              <h4 className="sg-event-form-heading">Professional Details</h4>

              <select required>
                <option value="">Current Profession *</option>
                <option>Student</option>
                <option>Working Professional</option>
                <option>Business Owner</option>
                <option>Real Estate Professional</option>
                <option>Investor</option>
                <option>Other</option>
              </select>

              <input type="text" placeholder="City *" required />

              <select required>
                <option value="">Interested in Real Estate As *</option>
                <option>Career</option>
                <option>Business</option>
                <option>Investment</option>
                <option>Learning Opportunity</option>
              </select>

              <button className="sg-event-btn primary">
                Submit Registration
              </button>

              <span
                className="sg-event-modal-close"
                onClick={() => setShowRegisterModal(false)}
              >
                ✕
              </span>
            </div>
          </div>
        </>
      )}

      {/* ================= FLOATING PRICE BADGE ================= */}
      <div
        className="sg-event-price-float"
        onClick={() => setShowRegisterModal(true)}
      >
        <div className="sg-event-price-old">Soon</div>
        <div className="sg-event-price-new">Soon</div>
      </div>


  
    </>
  );
};

export default Webinar;
